<script>
    import R from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../icons/AppIcon.svelte";
    import ControlLoader from "../ControlLoader.svelte";
    import ClientEditModal from "../../clients/ClientEditModal.svelte";
    import {setFocusTo} from "../../lib/lib";

    export let id = 'clientName';
    export let client = null;
    export let css = '';
    export let allowEdit = true;
    export let placeholder = '';
    export let disabled = false;

    let clientId = null;
    let name = '';
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let showNotFound = false;
    let editId = null;
    let loading = false;

    const dispatch = createEventDispatcher();

    const search = () => {
        const onSuccess = result => {
            results = result.clients;
            loading = false;
            showNotFound = results.length === 0;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.client.index, {term: name}, onSuccess, onFailure);
    }

    const onFocusOut = () => {
        if (client) {
            name = client.company;
        }
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        if (name != event.target.value) {
            showNotFound = false;
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }

            if (name.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }

    const clear = () => {
        client = null;
        clientId = null;
        showNotFound = false;
        dispatch("change");
    }

    const onSelect = (item) => {
        client = item;
        name = client.company;
        dispatch("change", client);
        closeDropdown();
    }

    const onClear = () => {
        clear();
        name = "";
        setFocusTo(id);
    }

    const closeEdit = (item) => {
        if (item) {
            if (!client) {
                client = {};
            }
            client.id = item.id;
            client.code = item.code;
            client.company = item.company;
            name = client.company;
        }
        editId = null;
    }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }

    $: {
        if (client) {
            if (clientId != client.id) {
                clientId = client.id;
                name = client.company;
            }
        } else {
            if (clientId != null && !client) {
                clientId = null;
                name = '';
            }
        }
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="input-group">
        <input type="text" class="form-control {css}" id="{ id }" value="{ name }" on:keydown="{ onKeyDown }"
               on:keyup="{ onKeyUp }"
               on:focusout="{ onFocusOut }"
               autocomplete="off"
               {placeholder} {disabled}>
        {#if allowEdit && !disabled}
            {#if client}
                <button class="btn btn-default" type="button" title="στοιχεία πελάτη"
                        on:click={ () => editId = client.id }>
                    <AppIcon icon="edit"/>
                </button>
            {:else}
                <button class="btn btn-default" type="button" title="νέος πελάτης" on:click={ () => editId = 0 }>
                    <AppIcon icon="plus-circle" strokeWidth="2"/>
                </button>
            {/if}
        {/if}

        {#if showNotFound}
            <div class="not-found">
                <AppIcon icon="exclamation-circle-solid" size="16"/>
            </div>
        {/if}
    </div>
    <ControlLoader {loading}/>

    {#if showDropdown}
        {#if results.length}
            <ul class="dropdown client-dropdown">
                {#each results as item, index}
                    <li class="dropdown-item d-flex align-items-center pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => onSelect(item) }">
                        <div class="code">
                            { item.code }
                        </div>
                        <div class="name">
                            { item.company }
                        </div>
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</div>
{#if editId != null}
    <ClientEditModal clientId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}

<style>
    .not-found {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        color: rgba(255, 0, 0, 0.5);
    }

    .client-dropdown {

    }

    .client-dropdown .dropdown-item .code {
        min-width: 40px;
        margin-right: 5px;
    }

    .client-dropdown .dropdown-item .name {
        width: calc(100% - 50px);
    }
</style>